(function () {
  'use strict';

  const FAMILY = {
    BASIC: 'Basic Sleeve',
    ACE: 'ACE Stabilized Sleeve',
    STRAP: 'Adjustable Strap Brace',
    HINGE: 'Hinged Knee Brace'
  };

  const PRODUCTS = {
    HX015: {
      position: 'Simple everyday compression',
      reason: 'HX015 is a straightforward pull-on sleeve that provides flexible compression without straps, kneecap padding, or side stabilizers.',
      tradeoff: 'Consider another style if you want cushioning around the kneecap, adjustable straps, or added side structure.'
    },
    HX052: {
      position: 'Two-pack with more size options',
      reason: 'HX052 is sold as a two-pack and comes in a wider range of sizes. It has a simple pull-on design with no added hardware.',
      tradeoff: 'It does not include kneecap padding, straps, or side stabilizers.'
    },
    HX038: {
      position: 'Ultra-light, breathable sleeve',
      reason: 'HX038 is the thinnest and most breathable of the three basic sleeves, making it easy to wear under clothing.',
      tradeoff: 'Its support feels lighter than HX015 and HX052, and it does not include added side structure.'
    },
    'ACE-50': {
      position: 'Softest, most breathable ACE option',
      reason: 'ACE-50 pairs kneecap cushioning and flexible side stabilizers with the softest feel and highest breathability in the ACE range.',
      tradeoff: 'It feels lighter and less wrapped than ACE-51 and ACE-53.'
    },
    'ACE-39': {
      position: 'Lightweight with a structured knit',
      reason: 'ACE-39 combines kneecap cushioning and flexible side support with a lightweight, slightly more structured knit.',
      tradeoff: 'Choose ACE-50 for the softest material feel, or ACE-51/53 for a thicker compression feel.'
    },
    'ACE-51': {
      position: 'Firmer compression with a softer feel',
      reason: 'ACE-51 combines kneecap cushioning and flexible side support with thicker compression and a more comfortable material feel than ACE-53.',
      tradeoff: 'It feels thicker and less breathable than ACE-50 and ACE-39.'
    },
    'ACE-53': {
      position: 'Firmer compression at a better value',
      reason: 'ACE-53 combines kneecap cushioning and flexible side support with a thicker compression feel at a more accessible price.',
      tradeoff: 'Choose ACE-51 if a more refined material feel matters more than price.'
    },
    HX046: {
      position: 'Lightweight, breathable adjustability',
      reason: 'HX046 combines breathable materials, two foam pads beside the kneecap, four fixed metal side stabilizers, and V-shaped straps.',
      tradeoff: 'It has less cushioning and a lighter support feel than HX054 and HX024.'
    },
    HX054: {
      position: 'Cushioned support with simple straps',
      reason: 'HX054 combines a full TPE kneecap ring, four fixed metal side stabilizers, and separate upper and lower straps.',
      tradeoff: 'Choose HX046 for a lighter feel, or HX024 for a more wrapped and cushioned X-shaped strap design.'
    },
    HX024: {
      position: 'Comfortable X-strap support',
      reason: 'HX024 combines X-shaped straps, two crescent-shaped gel pads, and four fixed metal side stabilizers.',
      tradeoff: 'Choose HX054 if you prefer a full kneecap ring and separate upper and lower straps.'
    },
    'HX035/HX042': {
      position: 'Structured hinged support with X-straps',
      reason: 'HX035/HX042 combines removable side hinges with front-crossing X-straps for a structured, wrapped feel.',
      tradeoff: 'It is thicker and less flexible than a compression sleeve or spring-stabilized strap brace.'
    },
    HX043: {
      position: 'Structured hinged support with simple straps',
      reason: 'HX043 combines removable side hinges with separate upper and lower straps for straightforward adjustment.',
      tradeoff: 'Choose HX035/HX042 if you prefer the more wrapped feel of front-crossing X-straps.'
    }
  };

  const QUESTIONS = [
    {
      id: 'q1',
      title: 'How will you use your knee brace most often?',
      helper: 'Choose the option that best reflects your usual routine.',
      options: [
        { id: 'walk', label: 'Walking, stairs & everyday errands', detail: 'Walking at home, running errands, or taking the stairs' },
        { id: 'work', label: 'Standing or moving for long periods', detail: 'Work, household tasks, or long periods on your feet' },
        { id: 'exercise', label: 'Exercise, hiking or gym workouts', detail: 'General fitness and active routines' },
        { id: 'sport', label: 'Running, court sports & faster movement', detail: 'Activities with quicker steps and changes of direction' }
      ]
    },
    {
      id: 'q2',
      title: 'How long do you expect to wear your brace at a time?',
      helper: 'This helps us weigh breathability, comfort, and structure.',
      options: [
        { id: 'short', label: 'For a walk, workout, or other short activity', detail: 'Usually less than two hours' },
        { id: 'several', label: 'For several hours at a time', detail: 'Comfort and a secure fit both matter' },
        { id: 'allDay', label: 'For most of the day', detail: 'Breathability and lower bulk are especially important' },
        { id: 'unsure', label: "I'm not sure yet", detail: 'Use my other answers to narrow it down' }
      ]
    },
    {
      id: 'q3',
      title: 'How would you prefer to put on your brace?',
      helper: 'Choose the style that would be easiest for you to use regularly.',
      options: [
        { id: 'sleeve', label: 'Pull it on with no straps to adjust', detail: 'A simple sleeve that slides over your foot and calf' },
        { id: 'wrap', label: 'Wrap it directly around my knee', detail: 'Opens fully and fastens with adjustable straps - no need to pull it over your foot' },
        { id: 'hinged', label: 'Pull it on, then adjust the straps', detail: 'A sleeve-style brace with adjustable straps and removable side hinges' },
        { id: 'either', label: "I don't have a preference", detail: 'Use my other answers to narrow it down' }
      ]
    },
    {
      id: 'q4',
      title: 'If you had to choose one, what would matter most?',
      helper: 'Choose the one that would make the biggest difference in day-to-day wear.',
      options: [
        { id: 'lightweight', label: 'Lightweight and breathable for longer wear', detail: 'Less heat and bulk during everyday use' },
        { id: 'cushioning', label: 'Cushioning around the kneecap', detail: 'More cushioning around the front of the knee' },
        { id: 'secure', label: 'Stays securely in place', detail: 'Less concern about shifting while you move' },
        { id: 'sideStructure', label: 'Firmer support along both sides', detail: 'A firmer, more structured feel at the sides' },
        { id: 'value', label: 'Better value or more size options', detail: 'Price, a two-pack, or a wider size range' }
      ]
    }
  ];

  const Q5 = {
    [FAMILY.BASIC]: {
      title: 'Which basic-sleeve design would you prefer?',
      helper: "We've narrowed it down. Choose the design detail you prefer.",
      options: [
        { id: 'basic-simple', label: 'One simple sleeve for everyday wear', primary: 'HX015', alternative: 'HX038' },
        { id: 'basic-pack', label: 'Two sleeves or a wider size range', primary: 'HX052', alternative: 'HX015' },
        { id: 'basic-thin', label: 'The thinnest, most breathable fit', primary: 'HX038', alternative: 'HX015' }
      ]
    },
    [FAMILY.ACE]: {
      title: 'Which ACE sleeve design would you prefer?',
      helper: "We've narrowed it down. Choose the design detail you prefer.",
      options: [
        { id: 'ace-soft', label: 'Softest material and highest breathability', primary: 'ACE-50', alternative: 'ACE-39' },
        { id: 'ace-light', label: 'Lightweight with a more structured knit', primary: 'ACE-39', alternative: 'ACE-50' },
        { id: 'ace-refined', label: 'Thicker compression with a softer material feel', primary: 'ACE-51', alternative: 'ACE-53' },
        { id: 'ace-value', label: 'Thicker compression at a better value', primary: 'ACE-53', alternative: 'ACE-51' }
      ]
    },
    [FAMILY.STRAP]: {
      title: 'Which adjustable-brace design would you prefer?',
      helper: "We've narrowed it down. Choose the design detail you prefer.",
      options: [
        { id: 'strap-light', label: 'A lighter, more breathable adjustable fit', primary: 'HX046', alternative: 'HX054' },
        { id: 'strap-ring', label: 'A full kneecap ring with separate upper and lower straps', primary: 'HX054', alternative: 'HX024' },
        { id: 'strap-x', label: 'X-shaped straps with extra cushioning and a more wrapped feel', primary: 'HX024', alternative: 'HX054' }
      ]
    },
    [FAMILY.HINGE]: {
      title: 'Which strap style would you prefer?',
      helper: "We've narrowed it down. Both options have a similar thickness and removable side hinges.",
      options: [
        { id: 'hinge-x', label: 'Front-crossing X-straps for a wrapped feel', primary: 'HX035/HX042', alternative: 'HX043' },
        { id: 'hinge-simple', label: 'Separate upper and lower straps', primary: 'HX043', alternative: 'HX035/HX042' }
      ]
    }
  };

  const ANSWER_COPY = {
    q1: { walk: 'walking, stairs, and everyday errands', work: 'standing or moving for long periods', exercise: 'exercise, hiking, or gym workouts', sport: 'running, court sports, and faster movement' },
    q2: { short: 'during shorter activities', several: 'for several hours at a time', allDay: 'for most of the day', unsure: 'for different lengths of time' },
    q3: {
      sleeve: 'a simple pull-on sleeve with no straps',
      wrap: 'a wrap-around brace that fastens directly around the knee',
      hinged: 'a pull-on brace with adjustable straps and side hinges',
      either: 'any of these wearing styles'
    },
    q4: { lightweight: 'lightweight breathability', cushioning: 'cushioning around the kneecap', secure: 'a secure, stay-in-place fit', sideStructure: 'firmer support along both sides', value: 'better value or more size options' }
  };

  function getFamilyDecision(answers) {
    const priority = answers.q4;
    const longerWear = answers.q2 === 'allDay';
    const activeUse = ['exercise', 'sport'].includes(answers.q1);
    const everydayUse = ['walk', 'work'].includes(answers.q1);

    if (answers.q3 === 'sleeve') {
      if (priority === 'lightweight' && activeUse && !longerWear) {
        return { primary: FAMILY.ACE, secondary: FAMILY.BASIC };
      }
      if (['lightweight', 'value'].includes(priority)) {
        return { primary: FAMILY.BASIC, secondary: FAMILY.ACE };
      }
      return { primary: FAMILY.ACE, secondary: FAMILY.BASIC };
    }

    if (answers.q3 === 'wrap') return { primary: FAMILY.STRAP, secondary: null };
    if (answers.q3 === 'hinged') return { primary: FAMILY.HINGE, secondary: null };

    if (priority === 'lightweight') {
      return activeUse && !longerWear
        ? { primary: FAMILY.ACE, secondary: FAMILY.BASIC }
        : { primary: FAMILY.BASIC, secondary: FAMILY.ACE };
    }
    if (priority === 'cushioning') return { primary: FAMILY.ACE, secondary: FAMILY.STRAP };
    if (priority === 'secure') {
      return longerWear && everydayUse
        ? { primary: FAMILY.ACE, secondary: FAMILY.STRAP }
        : { primary: FAMILY.STRAP, secondary: FAMILY.ACE };
    }
    if (priority === 'sideStructure') return { primary: FAMILY.HINGE, secondary: FAMILY.STRAP };
    return { primary: FAMILY.BASIC, secondary: FAMILY.ACE };
  }

  function pickProductForFamily(family, answers) {
    if (family === FAMILY.BASIC) {
      if (answers.q4 === 'value') return 'HX052';
      if (answers.q4 === 'lightweight' || answers.q2 === 'allDay') return 'HX038';
      return 'HX015';
    }
    if (family === FAMILY.ACE) {
      if (answers.q4 === 'value') return 'ACE-53';
      if (answers.q4 === 'lightweight') return 'ACE-50';
      if (answers.q1 === 'sport' && answers.q4 !== 'cushioning') return 'ACE-39';
      return 'ACE-51';
    }
    if (family === FAMILY.STRAP) {
      if (answers.q4 === 'lightweight' || answers.q2 === 'allDay') return 'HX046';
      if (answers.q4 === 'cushioning') return 'HX054';
      if (['secure', 'sideStructure'].includes(answers.q4)) return 'HX024';
      return 'HX046';
    }
    return ['exercise', 'sport'].includes(answers.q1) || answers.q4 === 'secure'
      ? 'HX035/HX042'
      : 'HX043';
  }

  function wearingReason(family) {
    if (family === FAMILY.BASIC) return 'Simple strap-free sleeve with no fasteners or added side hardware';
    if (family === FAMILY.ACE) return 'Strap-free sleeve with kneecap cushioning and flexible side supports';
    if (family === FAMILY.STRAP) return 'Opens fully and fastens directly around the knee - no need to pull it over your foot';
    return 'Pull-on design with adjustable straps and removable side hinges';
  }

  function useReason(answers) {
    const duration = {
      short: 'for a walk, workout, or other shorter activity',
      several: 'for several hours at a time',
      allDay: 'for most of the day',
      unsure: 'for different lengths of wear'
    }[answers.q2];
    return 'Selected with ' + ANSWER_COPY.q1[answers.q1] + ' in mind, ' + duration;
  }

  function routeNote(answers, family) {
    if (answers.q3 === 'sleeve' && answers.q4 === 'sideStructure') {
      return 'We prioritized your preference for a strap-free pull-on design. Within that format, an ACE sleeve adds flexible side supports without adjustable straps or hinged hardware.';
    }
    if (answers.q3 === 'wrap' && answers.q4 === 'sideStructure') {
      return 'We prioritized your preference for a wrap-around design that does not need to be pulled over your foot. This category uses fixed side stabilizers for a firmer feel along both sides.';
    }
    if (answers.q3 === 'hinged' && (answers.q4 === 'lightweight' || answers.q2 === 'allDay')) {
      return 'We prioritized your preference for a pull-on hinged brace. Hinged designs feel bulkier than sleeves, so review the trade-off below before choosing.';
    }
    if (answers.q3 === 'either' && family) {
      return 'More than one construction style matched your answers, so we included a second category for comparison.';
    }
    return '';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character];
    });
  }

  function publish(name, detail) {
    const eventName = 'neenca:brace_finder_' + name;
    window.dispatchEvent(new CustomEvent('knee_finder_' + name, { detail: detail }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'knee_finder_' + name }, detail || {}));
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(eventName, detail || {}).catch(function () {});
      }
    } catch (error) {}
  }

  function initFinder(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const products = JSON.parse(root.querySelector('[data-finder-products]').textContent);
    const settings = JSON.parse(root.querySelector('[data-finder-settings]').textContent);
    const quiz = root.querySelector('[data-finder-quiz]');
    const results = root.querySelector('[data-finder-results]');
    const unavailable = root.querySelector('[data-unavailable]');
    const form = root.querySelector('[data-finder-form]');
    const optionsNode = root.querySelector('[data-options]');
    const titleNode = root.querySelector('[data-question-title]');
    const helperNode = root.querySelector('[data-question-helper]');
    const legendNode = root.querySelector('[data-question-legend]');
    const stepLabel = root.querySelector('[data-step-label]');
    const progressBlock = root.querySelector('[data-progress-block]');
    const progressFill = root.querySelector('[data-progress-fill]');
    const backButton = root.querySelector('[data-back]');
    const continueButton = root.querySelector('[data-continue]');
    const continueLabel = root.querySelector('[data-continue-label]');
    const mobileActions = root.querySelector('[data-mobile-actions]');
    const mobileBackButton = root.querySelector('[data-mobile-back]');
    const mobileContinueButton = root.querySelector('[data-mobile-continue]');
    const mobileContinueLabel = root.querySelector('[data-mobile-continue-label]');
    const errorNode = root.querySelector('[data-error]');
    const productResults = root.querySelector('[data-product-results]');
    const resultSummary = root.querySelector('[data-result-summary]');
    let step = 0;
    let answers = {};

    function activeQuestion() {
      if (step < 4) return QUESTIONS[step];
      const family = getFamilyDecision(answers).primary;
      return Object.assign({ id: 'q5' }, Q5[family]);
    }

    function renderQuestion() {
      const question = activeQuestion();
      const selected = answers[question.id];
      titleNode.textContent = question.title;
      helperNode.textContent = question.helper;
      legendNode.textContent = question.title;
      stepLabel.textContent = 'Step ' + (step + 1) + ' of 5';
      progressBlock.setAttribute('aria-label', 'Step ' + (step + 1) + ' of 5');
      progressFill.style.width = ((step + 1) * 20) + '%';
      backButton.disabled = step === 0;
      mobileBackButton.disabled = step === 0;
      continueButton.disabled = !selected;
      mobileContinueButton.disabled = !selected;
      const actionLabel = step === 4 ? settings.resultsLabel : settings.continueLabel;
      continueLabel.textContent = actionLabel;
      mobileContinueLabel.textContent = actionLabel;
      errorNode.textContent = '';

      optionsNode.innerHTML = question.options.map(function (option) {
        const checked = selected === option.id;
        return '<label class="neenca-finder__option' + (checked ? ' is-selected' : '') + '">' +
          '<input type="radio" name="' + escapeHtml(question.id) + '" value="' + escapeHtml(option.id) + '"' + (checked ? ' checked' : '') + '>' +
          '<span class="neenca-finder__choice" aria-hidden="true">' + (checked ? '&#10003;' : '') + '</span>' +
          '<span><strong>' + escapeHtml(option.label) + '</strong>' + (option.detail ? '<small>' + escapeHtml(option.detail) + '</small>' : '') + '</span>' +
          '</label>';
      }).join('');
      titleNode.focus({ preventScroll: true });
      window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
    }

    function preferenceSummary() {
      if (answers.q3 === 'either') {
        return 'You do not have a strong preference about how the brace fastens. For ' +
          ANSWER_COPY.q1[answers.q1] + ', ' + ANSWER_COPY.q4[answers.q4] +
          ' matters most, and you expect to wear it ' + ANSWER_COPY.q2[answers.q2] + '.';
      }
      return 'Your answers point to ' + ANSWER_COPY.q3[answers.q3] + ' for ' +
        ANSWER_COPY.q1[answers.q1] + ', with ' + ANSWER_COPY.q4[answers.q4] +
        ' as the main priority. You expect to wear it ' + ANSWER_COPY.q2[answers.q2] + '.';
    }

    function primaryReasonsHtml(family, rule) {
      const reasons = [
        useReason(answers),
        wearingReason(family),
        'Your final design choice favors ' + rule.label.toLowerCase()
      ];
      return '<ul class="neenca-finder__match-list">' + reasons.map(function (reason) {
        return '<li>' + escapeHtml(reason) + '</li>';
      }).join('') + '</ul>';
    }

    function cardHtml(productId, isPrimary, context) {
      const product = products[productId];
      const copy = PRODUCTS[productId];
      if (!product || !copy) return '';
      const image = product.image ? '<a class="neenca-finder__product-image" href="' + escapeHtml(product.url) + '"><img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.imageAlt) + '" loading="lazy" decoding="async" width="450" height="450"></a>' : '';
      const price = settings.showPrice ? '<p class="neenca-finder__price">' + escapeHtml(product.price) + '</p>' : '';
      const matchContent = isPrimary
        ? primaryReasonsHtml(context.family, context.rule) + (context.note ? '<p class="neenca-finder__route-note">' + escapeHtml(context.note) + '</p>' : '')
        : '<p>' + escapeHtml(copy.reason) + '</p>';
      return '<article class="neenca-finder__product' + (isPrimary ? ' is-primary' : '') + '">' + image +
        '<div class="neenca-finder__product-body"><div class="neenca-finder__product-top"><span>' + (isPrimary ? 'Recommended starting point' : 'Another option to compare') + '</span><b>' + escapeHtml(productId) + '</b></div>' +
        '<h2>' + escapeHtml(product.title) + '</h2><p class="neenca-finder__position">' + escapeHtml(copy.position) + '</p>' + price +
        '<h3>' + (isPrimary ? 'Why it fits your answers' : 'Why you may prefer it') + '</h3>' + matchContent +
        '<div class="neenca-finder__tradeoff"><strong>What to know</strong><p>' + escapeHtml(copy.tradeoff) + '</p></div>' +
        '<a class="neenca-finder__product-link" href="' + escapeHtml(product.url) + '" data-product-id="' + escapeHtml(productId) + '" data-position="' + (isPrimary ? 'primary' : 'alternative') + '">' + escapeHtml(settings.viewProductLabel) + ' <span aria-hidden="true">&rarr;</span></a></div></article>';
    }

    function showResults() {
      const decision = getFamilyDecision(answers);
      const family = decision.primary;
      const rule = Q5[family].options.find(function (option) { return option.id === answers.q5; });
      let primaryId = rule.primary;
      const useCrossFamilyAlternative = answers.q3 === 'either' && decision.secondary;
      let alternativeId = useCrossFamilyAlternative
        ? pickProductForFamily(decision.secondary, answers)
        : rule.alternative;
      if (!products[primaryId] && products[alternativeId]) {
        primaryId = alternativeId;
        alternativeId = null;
      }

      quiz.hidden = true;
      mobileActions.hidden = true;
      if (!products[primaryId]) {
        unavailable.hidden = false;
        results.hidden = true;
        publish('complete', { primary_product: null, alternative_product: null, leading_family: family, configuration_error: true });
        return;
      }

      unavailable.hidden = true;
      results.hidden = false;
      resultSummary.textContent = preferenceSummary();
      productResults.innerHTML = cardHtml(primaryId, true, {
        family: family,
        rule: rule,
        note: routeNote(answers, family)
      }) + (alternativeId && products[alternativeId] ? cardHtml(alternativeId, false, null) : '');
      root.querySelector('[data-results-title]').focus({ preventScroll: true });
      window.scrollTo({ top: root.offsetTop, behavior: 'smooth' });
      publish('complete', {
        primary_product: primaryId,
        alternative_product: alternativeId && products[alternativeId] ? alternativeId : null,
        leading_family: family,
        alternative_family: useCrossFamilyAlternative ? decision.secondary : family,
        wearing_style: answers.q3
      });
    }

    optionsNode.addEventListener('change', function (event) {
      if (!event.target.matches('input[type="radio"]')) return;
      const question = activeQuestion();
      if (question.id !== 'q5') delete answers.q5;
      answers[question.id] = event.target.value;
      publish('answer', { question_id: question.id, option_id: event.target.value, step: step + 1 });

      // Keep the customer at the selected card and within reach of Continue.
      // Re-rendering here would run the question-level scroll and send mobile
      // users back to the top of the module after every answer.
      optionsNode.querySelectorAll('.neenca-finder__option').forEach(function (option) {
        const input = option.querySelector('input');
        const selected = input === event.target;
        option.classList.toggle('is-selected', selected);
        option.querySelector('.neenca-finder__choice').innerHTML = selected ? '&#10003;' : '';
      });
      continueButton.disabled = false;
      mobileContinueButton.disabled = false;
      errorNode.textContent = '';
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const question = activeQuestion();
      if (!answers[question.id]) {
        errorNode.textContent = 'Choose one option to continue.';
        return;
      }
      if (step === 4) showResults();
      else {
        step += 1;
        renderQuestion();
      }
    });

    function goBack() {
      if (step > 0) {
        step -= 1;
        renderQuestion();
      }
    }

    backButton.addEventListener('click', function () {
      goBack();
    });

    mobileBackButton.addEventListener('click', function () {
      goBack();
    });

    mobileContinueButton.addEventListener('click', function () {
      form.requestSubmit();
    });

    root.querySelector('[data-result-back]').addEventListener('click', function () {
      results.hidden = true;
      unavailable.hidden = true;
      quiz.hidden = false;
      mobileActions.hidden = false;
      renderQuestion();
    });

    root.querySelector('[data-restart]').addEventListener('click', function () {
      publish('restart', {});
      answers = {};
      step = 0;
      results.hidden = true;
      unavailable.hidden = true;
      quiz.hidden = false;
      mobileActions.hidden = false;
      renderQuestion();
    });

    productResults.addEventListener('click', function (event) {
      const link = event.target.closest('[data-product-id]');
      if (!link) return;
      publish('product_click', { product_id: link.dataset.productId, result_position: link.dataset.position });
    });

    publish('start', { placement: 'page_brace_finder' });
    renderQuestion();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-neenca-finder]').forEach(initFinder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();